import { render, staticRenderFns } from "./badgeUser.vue?vue&type=template&id=2c3f81c8&"
import script from "./badgeUser.vue?vue&type=script&lang=ts&"
export * from "./badgeUser.vue?vue&type=script&lang=ts&"
import style0 from "./badgeUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports